import {merge} from './merge';

export var validation = {
  create: function(test, options) {
    var defaultOptions = {
      onValid: function() {},
      onInvalid: function() {}
    };

    options = merge(options, defaultOptions);

    return {
      test: function(str) {
        var result = test(str);
        (result ? options.onValid : options.onInvalid)();
        return result;
      }
    };
  }
};
